var $provincia = document.getElementById("provincia")
var $distrito = document.getElementById("distrito")
var $departamento = document.getElementById("departamento")
var $ubigeoId = document.getElementById("ubigeo-id")
var $ubigeoCode = document.getElementById("ubigeo-code")
var $checkoutDni = document.getElementById("checkout_dni")
var $cartCheckout = document.getElementById("cart-checkout")
var $form = document.getElementById("form")
var $inputList = document.querySelectorAll("input")
var $hiddenInputs = document.querySelectorAll(".InputHide")
var shopRadioInputs = Array.from(document.querySelectorAll(".shopRadioInput"))



var $checkoutTipoDoc = document.getElementById("TipoDoc")


$cartCheckout.addEventListener("click", (e)=>{
  
	e.preventDefault()
    
    $form.action = `/cart?`
    
    const inputs = Array.from($inputList)
    console.info($hiddenInputs)

    $hiddenInputs.forEach((hiddenInput,index)=>{
		
      const inputValue = inputs.find((input)=>{
        if(input.name === hiddenInput.name.replace("attributes", "checkout")){
        console.log(input.name === hiddenInput.name.replace("attributes", "checkout"))
        console.log(hiddenInput.name.replace("attributes", "checkout"))

        return true
        }else{
        console.log(input.name === hiddenInput.name.replace("attributes", "checkout"))
        console.log(hiddenInput.name.replace("attributes", "checkout"))

        return false
        }
        
      }
        ).value
      
      if(inputValue === "" || inputValue === undefined){
      	hiddenInput.value = " "
        return
      }
      

      hiddenInput.value = inputValue
      
      if(inputValue !== undefined){
      
      console.info("Modified name", hiddenInput.name.replace("attributes", "checkout"))
      
      console.info("This is the value: " + inputValue.value)
      
      console.info(hiddenInput.value)
      }else{
      
      	console.error("This is the problem", $hiddenInuts[index])
      }
	})
    
    $inputList.forEach((input) => {
      
    
      if($form.action.charAt[$form.action.length - 1] === '?'){
        
        $form.action = $form.action + `${input.name}=${input.value}`
        
      }else{
      	
        $form.action = $form.action + `&${input.name}=${input.value}`
      }
    })
    
    $form.action += `&checkout[shipping_address][zip]=${$distrito.value}&checkout[shipping_address][city]=${$provincia.value}&checkout[shipping_address][province]=Lima (departamento)`
    
    
    $form.submit()

})

var match = new RegExp(/[0-9]$/)




    	$(".TipoDoc").fadeIn();
    	$(".TipoDoc").html("DNI");
      	$(".Documento").css("padding-left","5rem");
 


$checkoutTipoDoc.addEventListener("input", (e) => {

  
  
 
  
 
  if($checkoutTipoDoc.value == "Factura"){
    	$(".TipoDoc").fadeIn();
    	$(".TipoDoc").html("RUC");
    	$(".Documento").css("padding-left","5rem");

  }

  if($checkoutTipoDoc.value == "Boleta"){
    	$(".TipoDoc").fadeIn();
    	$(".TipoDoc").html("DNI");
    	$(".Documento").css("padding-left","5rem");

  
  }
  
  
  
  
})


$checkoutDni.addEventListener("input", (e) => {

          if(match.test($checkoutDni.value) !== true || $checkoutDni.value.length >= 12){
                $checkoutDni.value = $checkoutDni.value.split(/(.$)/)[0] 

          }



}) 





var setButtonProperty = (property, value) => {
  

  if($cartCheckout) $cartCheckout[property] = value

}

setButtonProperty("disabled", true)




var getData = async () => {
	
  const data = await fetch("//motorato.cluster.global/cdn/shop/t/5/assets/ubigeo.json?v=68167909384285913891619970971")
    .then((res)=> res.json())
    
  return data
}

var appendOptions = (data, filterElement, forElement, optionProperty, mapProperty)=>{

  const filtro = data.filter((option) => {
    if(filterElement.value === "--SELECCIONAR--"){
    	return option[optionProperty] === filterElement[1].value
    }else{
    	return option[optionProperty] === filterElement.value
    }
  })
  
  const set = new Set(filtro.map(val => val[mapProperty]).sort((a, b) => {
    if(a < b) { return -1; }
    if(a > b) { return 1; }
    return 0;
}))
  forElement.innerHTML = `<option class="${mapProperty}">--SELECCIONAR--</option>`

  set.forEach((option)=>{
    const $option = htmlToElement(option, mapProperty);
      forElement.appendChild($option);
  })
  
  if($provincia.value === $provincia[0].value || $distrito.value === $distrito[0].value){
    setButtonProperty("disabled", true)
  }
  
  if($provincia.value !== $provincia[0].value && $distrito.value !== $distrito[0].value){
    setButtonProperty("disabled", false)

  }
  
}


var htmlToElement = (data, name) => {
  let html
  if(data === "LIMA" && name === "departamento"){
  	html = `<option class="${name}" selected="selected">${data}</option>`;
  }else{
  	html = `<option class="${name}">${data}</option>`;
  }
    const template = document.createElement('template');
    html = html.trim();
    template.innerHTML = html;
    return template.content.firstChild;
}




var showDefaultOptions = (data, inputBase, target, ubigeoValue, result) =>{
  
 const ubigeos = data.map(ubigeo => {
   
   if(inputBase.value === "--SELECCIONAR--"){
        if(ubigeo[ubigeoValue] === inputBase[1].value) return ubigeo[result]
   }else if(inputBase.value === ubigeo[ubigeoValue]){
   	    return ubigeo[result]
   }
 })
 
 const totalValues = new Set(ubigeos)
 
 totalValues.forEach((value) =>{   
  if(value){
    const $option = htmlToElement(value, result);
    target.appendChild($option);
  }})
}



(async () => {
  
const data = await getData()

const departamentos = new Set(data.map(ubigeo => ubigeo.departamento).sort((a, b) => {
    if(a < b) { return -1; }
    if(a > b) { return 1; }
    return 0;
}))
departamentos.forEach((option) =>{
  	
  const $option = htmlToElement(option, "departamento");
  $departamento.appendChild($option);
  
})

showDefaultOptions(data, $departamento, $provincia, "departamento", "provincia")
showDefaultOptions(data, $provincia, $distrito, "provincia", "distrito")


$departamento.addEventListener("change", ()=>{
  	
	appendOptions(data, $departamento, $provincia, "departamento", "provincia")
  	appendOptions(data, $provincia, $distrito, "provincia", "distrito")	
    


})

$provincia.addEventListener("change", ()=>{
  	
  	appendOptions(data, $provincia, $distrito, "provincia", "distrito")	

})

$distrito.addEventListener("change", ()=>{
  		
 if($provincia.value === $provincia[0].value || $distrito.value === $distrito[0].value){
    setButtonProperty("disabled", true)
  }
  
  if($provincia.value !== $provincia[0].value && $distrito.value !== $distrito[0].value){
    setButtonProperty("disabled", false)
  }

  const ubigeo =  data.find((ubigeo) =>{ 
    if($provincia.vale !== "--SELECCIONAR--"){
      return ubigeo.departamento === $departamento.value && ubigeo.provincia === $provincia.value && ubigeo.distrito === $distrito.value
    }
  })
  
  $ubigeoId.value = ubigeo.id
  $ubigeoCode.value = ubigeo.ubigeo
})

})()


